module.exports = __webpack_public_path__ + "img/郁李仁.8fb5fc96.jpg";